import { create } from 'zustand';
import { CertificateResponse } from '../api/Students/CreateCertificate';

interface CertificateState {
  certificateData: CertificateResponse | null;
  setCertificateData: (data: CertificateResponse) => void;
}

export const useCertificateStore = create<CertificateState>((set) => ({
  certificateData: null,
  setCertificateData: (data) => set({ certificateData: data }),
}));
